import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_COUPON_FAILURE,
  CREATE_COUPON_REQUEST,
  GET_ALL_COUPON_SUCCESS,
  GET_ALL_COUPON_REQUEST,
  GET_ALL_COUPON_FAILURE,
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_FAILURE,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_FAILURE,
  DELETE_COUPON_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllCoupon = () => async (dispatch) => {
  dispatch({ type: GET_ALL_COUPON_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/coupons`);
    dispatch({ type: GET_ALL_COUPON_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_COUPON_FAILURE, payload: error.message });
  }
};

export const createCoupon = (couponData) => async (dispatch) => {
  dispatch({ type: CREATE_COUPON_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/coupon`, couponData);
    if (data.status === "SUCCESS") {
      dispatch(getAllCoupon());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_COUPON_FAILURE, payload: error.message });
  }
};

export const updateCoupon = (couponId, couponData) => async (dispatch) => {
  dispatch({ type: UPDATE_COUPON_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/coupon/${couponId}`,
      couponData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllCoupon());
      toast.success("Coupon Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_COUPON_FAILURE, payload: error.message });
  }
};

export const deleteCoupon = (couponId) => async (dispatch) => {
  dispatch({ type: DELETE_COUPON_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/coupon/${couponId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_COUPON_SUCCESS, payload: couponId })
      dispatch(getAllCoupon());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_COUPON_FAILURE, payload: error.message });
  }
};
